import React from "react";
import { Checkbox as ChakraCheckbox } from "@chakra-ui/react";

interface CheckboxProps {
  filterKey: string;
  label: string;
  updateFilter: (filterKey: string, value: any) => void;
  defaultValue?: any;
}

function Checkbox({
  filterKey,
  label,
  updateFilter,
  defaultValue,
}: CheckboxProps) {
  const value =
    typeof defaultValue === "boolean"
      ? defaultValue
      : defaultValue === "true"
      ? true
      : false;

  return (
    <ChakraCheckbox
      isChecked={value}
      onChange={(e) => {
        updateFilter(filterKey, e.target.checked);
      }}
    >
      {label}
    </ChakraCheckbox>
  );
}

export default Checkbox;
